<sb-key-value-list [keyValues]="data" useTableStyle="true"></sb-key-value-list>
